import { Injectable } from '@angular/core';
import { ServiceModule } from '../../../service.module';
import { Subject } from 'rxjs';
import { ResourceModel } from '../../../../core/models/resources/resource.model';

@Injectable({ providedIn: ServiceModule })
export class ResourceNotificationService {
    resourceCreatedSubject = new Subject<{ parentResource: ResourceModel; createdResource: any }>();

    public getResourceCreatedObservable() {
        return this.resourceCreatedSubject.asObservable();
    }

    public resourceCreated(parentResource: ResourceModel, createdResource: any) {
        this.resourceCreatedSubject.next({ parentResource: parentResource, createdResource: createdResource });
    }
}
